import m from "../../geodata/es2015/georgiaLow";
window.am4geodata_georgiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/georgiaLow.js
// module id = null
// module chunks = 